export default class Emitter {
  constructor() {
    this.__observers = [];
  }

  $subscribe(fn) {
    this.__observers
      .push(fn);
    return () => {
      this.__observers = this.__observers.filter(observer => observer !== fn);
    };
  }

  $dispatch(...agr) {
    this.__observers
      .forEach(observer => observer(...agr));
    return this;
  }
}
